<div class="condition-types">
  <div class="title">
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.condition-types.title"></sc-dictionary-label>
  </div>

  <div class="filter-type-groups">
    @for (group of conditionGroups; track group) {
      <div class="filter-type-group">
        <div class="group-title">
          <sc-dictionary-label [dictionaryKey]="group.nameDictionaryKey"></sc-dictionary-label>
        </div>
        @for (type of group.types; track type) {
          <div class="filter-type">
            <div class="drag-handle" draggable="true" (dragstart)="onDragTypeStart($event, type)"
              (dragend)="onDragTypeEnd($event)">
              <div aria-hidden="false">
                <sc-icon iconClass="fa-bars"></sc-icon>
              </div>
            </div>
            <div class="type-label">
              <sc-dictionary-label [dictionaryKey]="type.nameDictionaryKey"></sc-dictionary-label>
            </div>
          </div>
        }
      </div>
    }
  </div>

</div>
